import React, { PropsWithChildren } from 'react';
import styled, { CSSObject } from '@emotion/styled';

import { GroupContextProvider } from './GroupContext';

import { Label } from './Label';
import { Control } from './Control';
import { Error } from './Error';
import { Warning } from './Warning';

interface IStyledGroupProps {
  direction: CSSObject['flexDirection'];
  align: CSSObject['alignItems'];
  justify: CSSObject['justifyContent'];
  gap: number;
}

const StyledGroup = styled.div<IStyledGroupProps>(({
  direction, align, justify, gap,
}) => {
  const styles: CSSObject = {
    display: 'flex',
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    gap: `${gap}px`,
  };

  return styles;
});

interface IGroupProps extends PropsWithChildren {
  className?: string;
  direction?: CSSObject['flexDirection'];
  align?: CSSObject['alignItems'];
  justify?: CSSObject['justifyContent'];
  gap?: number;
  isInvalid?: boolean;
}

export const Group = ({
  className,
  gap = 8,
  direction = 'column',
  align = 'normal',
  justify = 'normal',
  isInvalid = false,
  children,
}: IGroupProps) => {
  return (
    <GroupContextProvider isInvalid={isInvalid}>
      <StyledGroup
        className={className}
        direction={direction}
        align={align}
        justify={justify}
        gap={gap}
      >
        {children}
      </StyledGroup>
    </GroupContextProvider>
  );
};

Group.Label = Label;
Group.Control = Control;
Group.Error = Error;
Group.Warning = Warning;
